import { ConfirmationResult } from "firebase/auth";
import { sendPhoneOtp } from "./firebasePhoneAuth";

export const sendOtp = async (phoneNumber: string, containerId: string): Promise<ConfirmationResult> => {
  return sendPhoneOtp(phoneNumber, containerId);
};
